var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';


const PreviewPropertyIcon = ({ className }) => /*#__PURE__*/
_jsx("svg", {
  className: className || '',
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "2 2 20 20" }, void 0, /*#__PURE__*/

_jsx("g", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }, void 0, /*#__PURE__*/
_jsx("path", { d: "m19 3h-14a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-14a2 2 0 0 0 -2-2z" }), /*#__PURE__*/
_jsx("path", { d: "m9 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm12 4-3.086-3.086a2 2 0 0 0 -2.828 0l-9.086 9.086" })
)
);


export { PreviewPropertyIcon };